import React, { useState, useEffect } from "react";

import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import { Button } from "@mui/material";
import { db } from "../firebase";
import ReactQuill from "react-quill"; // Import de ReactQuill
import "react-quill/dist/quill.snow.css"; // Import des styles pour Quill

function EmailTemplateEditor() {
  const [templateContent, setTemplateContent] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [, setPreviewContent] = useState("");

  const variables = {
    firstName: "John",
    lastName: "Doe",
    contactInfo: "john.doe@example.com",
    assignedTherapist: "Dr. Smith",
    assessmentDetails: "No assessment details available",
    clientId: "12345",
  };

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        console.log("Fetching template...");
        const templateRef = doc(db, "emailTemplates", "incomingClient");
        const templateDoc = await getDoc(templateRef);
        if (templateDoc.exists()) {
          // setTemplateContent(templateDoc.data().content);
          const content = templateDoc.data().content;
          console.log("Template fetched from Firestore:", content);
          setTemplateContent(content);
        } else {
          const defaultContent = "<p>Your default email template here.</p>";
          await setDoc(templateRef, { content: defaultContent });
          setTemplateContent(defaultContent);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
        alert("An error occurred while fetching the template.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplate();
  }, []);

  console.log("Email template: ", templateContent);

  const replaceTemplateVariables = (template, variables) => {
    return template.replace(
      /{{\s*(\w+)\s*}}/g,
      (match, p1) => variables[p1] || ""
    );
  };

  const handleEditorChange = (content, delta, source, editor) => {
    console.log("Editor content changed:", content);
    setTemplateContent(content);
  };

  // Mettre à jour la prévisualisation chaque fois que le template ou les variables changent
  useEffect(() => {
    const updatedPreview = replaceTemplateVariables(templateContent, variables);
    setPreviewContent(updatedPreview);
  }, [templateContent]);

  const handleSave = async () => {
    try {
      console.log("Saving template...");
      const templateRef = doc(db, "emailTemplates", "incomingClient");
      await updateDoc(templateRef, {
        content: templateContent,
      });
      alert("Template updated successfully");
    } catch (error) {
      console.error("Error saving template:", error);
      alert("An error occurred while saving the template.");
    }
  };

  if (isLoading) {
    return <div>Loading template...</div>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <h2>Edit Incoming Client Email Template</h2>
      <div>
        <p>You can use the following variables in your template:</p>
        <ul>
          <li>
            <code>{"{{ firstName }}"}</code>
          </li>
          <li>
            <code>{"{{ lastName }}"}</code>
          </li>
          <li>
            <code>{"{{ contactInfo }}"}</code>
          </li>
          <li>
            <code>{"{{ assignedTherapist }}"}</code>
          </li>
          <li>
            <code>{"{{ assessmentDetails }}"}</code>
          </li>
          <li>
            <code>{"{{ clientId }}"}</code>
          </li>
        </ul>
      </div>
      {/* <TextareaAutosize
        value={templateContent}
        onChange={(e) => setTemplateContent(e.target.value)}
        minRows={15}
        style={{ width: "100%", fontFamily: "monospace", fontSize: "14px" }}
      /> */}

      <ReactQuill
        defaultValue={templateContent}
        // onChange={setTemplateContent}
        onChange={handleEditorChange}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            ["link", "blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        }}
        formats={[
          "header",
          "bold",
          "italic",
          "underline",
          "link",
          "blockquote",
          "code-block",
          "list",
          "bullet",
        ]}
        style={{ height: "200px", marginBottom: "40px" }}
      />
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        style={{ marginTop: "10px" }}
      >
        Save Template
      </Button>
    </div>
  );
}

export default EmailTemplateEditor;
